import TTHardBreak from '@tiptap/extension-hard-break';

export const MarkdownHardBreak = TTHardBreak.extend({
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        if (this.editor.isActive('codeBlock')) {
          return false;
        }
        const nodeBefore = this.editor.state.selection.$anchor.nodeBefore;
        const nodeAfter = this.editor.state.selection.$anchor.nodeAfter;
        if (
          (nodeBefore &&
            nodeBefore.type.name !== 'hardBreak' &&
            nodeAfter?.type.name !== 'hardBreak') ||
          !this.editor.isActive('paragraph')
        ) {
          return this.editor.commands.createParagraphNear();
        }
        if (
          !nodeBefore &&
          !nodeAfter &&
          (this.editor.isActive('orderedList') ||
            this.editor.isActive('bulletList'))
        ) {
          //exit list on second Enter
          return false;
        }
        return true;
      },
      'Shift-Enter': () => {
        const nodeBefore = this.editor.state.selection.$anchor.nodeBefore;
        const nodeAfter = this.editor.state.selection.$anchor.nodeAfter;
        if (this.editor.isActive('codeBlock')) {
          return this.editor.commands.exitCode();
        }
        if (nodeBefore && nodeAfter) {
          if (
            this.editor.isActive('orderedList') ||
            this.editor.isActive('bulletList') ||
            this.editor.isActive('heading')
          ) {
            return true;
          }
          return this.editor.commands.setHardBreak();
        }
        return true;
      },
    };
  },
});
